import { enqueueOrRun } from '@frameio/segment-ot';
import type { Sections } from '../../routing/pages/settings';
import type { PageType } from '../../routing/types';
import type { ContextForAnalytics } from '../hooks/useCoreOptionsForAnalytics';

export const trackPageView = (
  pageViewIdentifier: PageType | Sections | null | undefined,
  context: ContextForAnalytics
): void => {
  if (!pageViewIdentifier) return;
  if (!window.analytics) return;

  // analytics.page(category, name, properties, undocumentedFieldWhichContainsIntegrations)
  // Segment will setup the `properties` object for us, no need to do it ourselves
  // https://segment.com/docs/connections/spec/page/#properties
  enqueueOrRun({
    event: () =>
      window.analytics.page(
        pageViewIdentifier,
        undefined,
        {
          // ensure we redact UGC (eg. share/project/workspace names)
          title: `Page | ${pageViewIdentifier}`,
        },
        {
          integrations: 'integrations' in window && window.integrations,
          context,
          ...context?.consent,
        }
      ),
  });
};
